<div class="atn-summit-org-chart">
  <div class="atn-summit-org-chart__main-panel">
    <atn-summit-org-chart-tools class="atn-summit-org-chart__tools" />
    <atn-summit-org-chart-graph class="atn-summit-org-chart__graph" />
  </div>
  <atn-summit-org-chart-node-panel class="atn-summit-org-chart__node-panel" />
</div>
